import { Outlet } from "react-router-dom"
import Footer from "./Footer"
import Header from "./Header"

const Layout = () => {
  return (
    <div className="flex flex-col bg-[#ededed] h-full min-h-screen">
      <Header />
      <Outlet />
      <Footer />
    </div>
  )
}

export default Layout
